var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-component__scroll",attrs:{"id":"app"}},[_c('headerMenu'),_vm._v(" "),_c('div',{staticClass:"app-top"}),_vm._v(" "),_c('router-view'),_vm._v(" "),(_vm.route.name !== 'parterDialog')?_c('customerFooter'):_vm._e(),_vm._v(" "),_c('el-backtop',{attrs:{"bottom":100}},[_c('img',{staticClass:"re-top",attrs:{"id":"re_top","src":_vm.reTopUrl}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-904e23c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 